export const JOB_INVOCATIONS_POLLING_STARTED =
  'JOB_INVOCATIONS_POLLING_STARTED';
export const JOB_INVOCATIONS_GET_JOB_INVOCATIONS =
  'JOB_INVOCATIONS_GET_JOB_INVOCATIONS';
export const JOB_INVOCATIONS_JOB_FINISHED = 'JOB_INVOCATIONS_JOB_FINISHED';



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/react_app/redux/consts.js